import { IStyleConfig, mergeStyles, VisualSize } from '@cian/components';
import * as React from 'react';

import { Box } from '../../ui/box/box';
import { PikLink } from '../../ui/pik_link/pik_link';
import { Slider } from '../../ui/slider/slider';
import { connect } from 'react-redux';
import { IApplicationState } from '../../types/redux';
import { IBannerData } from '../../../typings/api';

const styles = require('./banner.css');

const slideStyles = (visible: boolean, slideClass: IStyleConfig) =>
  mergeStyles(visible && styles.slide, slideClass, !visible && styles.invisible);

interface IBannerProps {
  banners: IBannerData[];
}

class BannerComponent extends React.PureComponent<IBannerProps, object> {
  public render() {
    if (this.props.banners.length === 0) {
      return null;
    }

    const slides = this.createSlides(this.props.banners);

    return (
      <div className={styles['banner']}>
        <Slider interval={6000} slides={slides} />
      </div>
    );
  }

  private createSlides = (slidesData: IBannerData[]) =>
    slidesData.map(slide => (visible: boolean, key: number) => {
      const url = slide.publicUrl;
      const stylesCss = slideStyles(visible, { backgroundImage: `url(${slide.imageUrl})` });

      return (
        <div key={slide.id + (slide.title || '') + key} {...stylesCss}>
          <div className={styles.content}>
            {/* перехватываем событие, чтобы можно было выделять текст */}
            <div className={styles.texts} onClick={e => e.stopPropagation()}>
              <p className={styles.title}>{this.transformTitle(slide.title)}</p>
              <p className={styles.label}>{slide.label}</p>
            </div>
            {url && (
              <Box top={65}>
                <PikLink theme="button/solid" pikTheme="orange" size={VisualSize.LARGE} target="_blank" href={url}>
                  Выбрать квартиру
                </PikLink>
              </Box>
            )}
          </div>
        </div>
      );
    });

  private transformTitle = (title: string | undefined) => {
    //некоторые ЖК имеют дублирующее название на русском в скобках - вырезаем его
    return title?.replace(/(.+)\((.+)\)/g, '$1');
  };
}

export const Banner = connect((state: IApplicationState) => ({
  banners: state.banners || [],
}))(BannerComponent);
